// extracted by mini-css-extract-plugin
export default {"challenge":"Activity_challenge__pn0QF","offset":"Activity_offset__0B5Dh"};